import SingleOfferTemplatLoader from "./SingleOfferTemplatLoader";
import {
    bannerFetchInitData,
    bannerReadyToShowAD
} from "../../api";

class BannerSingleOfferTemplatLoader extends SingleOfferTemplatLoader{
    constructor(...arg){
        super(...arg)
    }

    loadTemplate(TemplateClass, cb, fetchFun = bannerFetchInitData) {
        return super.loadTemplate(TemplateClass, cb, fetchFun)
    }
}

export default BannerSingleOfferTemplatLoader